import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tag } from '../types';

export interface TagFilterOption {
    tag: Tag;
    count: number;
}

interface RecordingsTagFilterProps {
    /** Actieve tagfilters; bij een lege lijst rendert de banner niet */
    selectedTags: Tag[];
    onRemoveTag: (tagId: number) => void;
    onClear: () => void;
}

export const getTagDisplayName = (tagName: string) =>
    tagName.length > 30 ? tagName.substring(0, 30) + '...' : tagName;

/**
 * Banner die alleen verschijnt zolang er een tagfilter actief is (zelfde patroon
 * als de dagfilter-banner). Tags selecteren gebeurt via het zoekpaneel of door
 * op een tag op een opnametegel te klikken.
 */
const RecordingsTagFilter: React.FC<RecordingsTagFilterProps> = ({ selectedTags, onRemoveTag, onClear }) => {
    const { t } = useTranslation();

    if (selectedTags.length === 0) {
        return null;
    }

    return (
        <div className="animate-fade-in flex flex-wrap items-center gap-2 rounded-xl border border-primary-100 bg-container px-4 py-2.5 text-sm">
            <span style={{ color: 'var(--text)' }}>{t('recordingsPage.tagFilter.filteredOn')}</span>
            {selectedTags.map(tag => (
                <button
                    key={tag.id}
                    onClick={() => onRemoveTag(tag.id)}
                    title={t('recordingsPage.tagFilter.remove', { name: tag.name })}
                    className="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium text-white transition-opacity hover:opacity-90"
                    style={{ backgroundColor: tag.color }}
                >
                    <span>{getTagDisplayName(tag.name)}</span>
                    <svg className="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5} aria-hidden="true">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            ))}
            <button
                onClick={onClear}
                className="ml-auto font-semibold text-primary-700 hover:underline"
            >
                {t('recordingsPage.tagFilter.clear')}
            </button>
        </div>
    );
};

export default RecordingsTagFilter;
